import { Injectable } from '@angular/core';
import { Resource } from '@df/catalog/resource';
import { Question } from './question';

declare module '@df/catalog/resource' {
    interface IResources {
        question: Resource<Question, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class QuestionResource extends Resource<Question, number> {
    static override instance = Question;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = false;
}
